<template>
    <div class="dml-article" data-t="24.2">
        <span v-if="title" class="dml-article__title _dot">{{title}}</span>
        <dm-scrollable-list innerClassName="dml-article__banners"
                            :itemsInViewport="4">
            <template slot="items">
                <li v-for="article in articles"
                    class="dml-article-banner"
                    :key="article.id">
                    <a :class="['dml-article-banner__wrapper', {'dml-article-banner__wrapper--square': squareTiles}]"
                       :href="article.url" rel="nofollow"
                       v-on:click="handleClick(article.title)">
                        <div class="dml-article-banner__media">
                            <img class="dml-article-banner__image lazy"
                                 src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                 :data-src="article.imageUrl"
                                 :alt="article.title" />
                        </div>
                        <span class="dml-article-banner__title">{{article.teaser}}</span>
                    </a>
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';

    export default {
        name: 'dm-articles',
        components: {
            'dm-scrollable-list': ScrollableListComponent,
        },
        props: {
            title: {
                type: String,
                required: false
            },
            articles: {
                type: Array,
                required: true
            },
            squareTiles: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleClick(title) {
                this.$emit('articleClicked', title);
            }
        }
    };
</script>
